import {isFutureDate} from '@sollapay/utils';
import {z} from 'zod';

import type {StringFieldRule, Translate} from './id-field-rules';

/** Adds a `common:futureDateNotAllowed` issue when `value` is non-empty and later than today. Shared by every Zod `superRefine` guarding a date field that can never be in the future (date of birth, incorporation/established date). */
export function addFutureDateIssue(ctx: z.RefinementCtx, field: string, value: string): void {
  if (value && isFutureDate(value)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: [field],
      message: 'common:futureDateNotAllowed'
    });
  }
}

/**
 * RHF `validate` rule rejecting a future date — spread alongside a field's own `required` message,
 * since forms whose `useForm()` has no Zod `resolver` never run `addFutureDateIssue` on submit.
 */
export function futureDateRule(t: Translate): {validate: StringFieldRule['validate']} {
  return {
    validate: value => !value || !isFutureDate(value) || t('common:futureDateNotAllowed')
  };
}
